import { useCallback } from 'react';

import { client, useFormErrorHandler } from 'core/http';
import { UserSchema } from 'core/schemas/user';
import { User } from 'core/types/user';

export default function useUserCreates() {
  const handleFormErrors = useFormErrorHandler();

  return useCallback((payload: UserSchema) => {
    return client()
      .post<User>(`users`, payload)
      .then(response => response.data)
      .catch(handleFormErrors);
  }, [handleFormErrors]);
}
